import { logUsage } from 'owa-analytics';
import { SharingTipId } from 'owa-sharing-data';

export function logIgnoreSharingTipDatapoint(sharingTipId: SharingTipId) {
    logUsage('AttachmentLinkSharingTipIgnored', [sharingTipId]);
}

export function logRefreshExpirationDatapoint(sharingTipId: SharingTipId) {
    logUsage('LinkRefreshedSharingTip', [sharingTipId]);
}

export function logChangePermsSharingTipDatapoint(sharingTipId: SharingTipId) {
    logUsage('LinkChangePermermissionContextualSharingTip', [sharingTipId]);
}
